import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { last } from 'rxjs';
import { UsersService } from 'src/app/services/users.service';
import Swal from 'sweetalert2';
import { MatTabsModule } from '@angular/material/tabs';
import { DistributionsService } from 'src/app/services/distributions.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-bulk-config',
  templateUrl: './bulk-config.component.html',
  styleUrls: ['./bulk-config.component.scss']
})
export class BulkConfig implements OnInit {
campana: any;
  formBulk!: FormGroup;
  countriesList: any = [];
  selectedPais: any;
  commissionTypesList: any = [];
  tipoCom!: {
    id: string,
    nombre: string
  }[];
  tipoComSel: string = "porc";
  selected : any = [];

  providersList: any = [];
  carriersList: any = [];
  carriersListFiltered: any = [];
  carriersListTemp: any = [];

  providersCarriers: any[] = [];
  
  constructor(
    private fb: FormBuilder,
    private distService : DistributionsService,
    private userS: UsersService,
    private dialogRef: MatDialogRef<BulkConfig>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any // Inyecta los datos del diálogo
    ) {
        this.campana = data.campaign; // Asigna el dato recibido
    }

  ngOnInit(): void {
    this.tipoCom = [{"id": "porc", "nombre": "Porcentaje"},{"id": "cant", "nombre": "Cantidad"}];
    this.createForm();
    //this.getCompanyProvidersCarriers();
    this.getBulkConfig();
    // Escucha cambios en bulkProviders para filtrar bulkCarriers
    this.formBulk.get('bulkProviders')?.valueChanges.subscribe(() => {
        this.filterBulkCarriers();
    });

    const groupAttemptsCtrl = this.formBulk.get('group_attempts');
    const toggleCtrl = this.formBulk.get('group_attempts_active');

    // Escucha cambios en el toggle
    toggleCtrl?.valueChanges.subscribe((isActive: boolean) => {
      if (isActive) {
        groupAttemptsCtrl?.enable();
      } else {
        groupAttemptsCtrl?.disable();
      }
    });

    // Aplica el estado inicial al cargar
    if (!toggleCtrl?.value) {
      groupAttemptsCtrl?.disable();
    }
  }

  createForm() {
    this.formBulk = this.fb.group({
      bulkProviders:['',[]],
      bulkCarriers:['',[]],
      guide_attempts: [2,[Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(0), Validators.max(5)]],
      group_attempts: [5,[Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(0), Validators.max(10)]],
      guide_attempts_active: [false,[]],
      group_attempts_active: [false,[]],
      upd_on_general_config: [false,[]]
    });
  }

  getBulkConfig() {
    this.distService.getBUConfig(this.campana.id).subscribe(
      (result: any) => {
        if (result.message === "Success" && result.data) {
          // Convierte los strings a arrays de números
          let bulkProviders: any[] = [];
          let bulkCarriers: any[] = [];
          try {
            bulkProviders = JSON.parse(result.data.providers || '[]');
            bulkCarriers = JSON.parse(result.data.carriers || '[]');
          } catch (e) {}

          this.formBulk.controls['bulkProviders'].setValue(bulkProviders);
          this.formBulk.controls['bulkCarriers'].setValue(bulkCarriers);
          this.formBulk.controls['guide_attempts'].setValue(result.data.guide_attempts ?? 1);
          this.formBulk.controls['group_attempts'].setValue(result.data.group_attempts ?? 1);
          this.formBulk.controls['guide_attempts_active'].setValue(result.data.guide_attempts_active ?? false);
          this.formBulk.controls['group_attempts_active'].setValue(result.data.group_attempts_active ?? false);
        }
        this.getCompanyProvidersCarriers(() => {
            this.filterBulkCarriers();
        });
      }
    );
  }

  randomString(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  getLastWord(words:string):string  {
    let aWords=words.split(' ');
    let lastWord=aWords[aWords.length-1];
    return `${lastWord.charAt(0).toUpperCase()}${lastWord.slice(1)}`;
  }

  getCompanyProvidersCarriers(callback?: () => void) {
    this.distService.getCompanyProvidersCarriers().subscribe(
      (result: any) => {
        this.providersList = result.providersList;
        this.carriersList = result.carriersList;
        this.providersCarriers = result.providersCarriers || [];
        this.carriersListFiltered = [...this.carriersList];
        this.cd.detectChanges();
        if (callback) callback();
      },
      (err: any) => {
        console.log(err);
        if (callback) callback();
      }
    );
  }

  filterBulkCarriers() {
    const selectedProviders = this.formBulk.get('bulkProviders')?.value || [];
    // providersCarriers[1] contiene la relación proveedor-carrier
    const carriersByProvider = this.providersCarriers[1] || [];

    // Filtra carriers que correspondan a los proveedores seleccionados
    const filteredCarriers = carriersByProvider
      .filter((c: any) => selectedProviders.includes(c.id_provider))
      .map((c: any) => c.id);

    // carriersList contiene todos los carriers posibles
    this.carriersListFiltered = this.carriersList.filter((c: any) =>
      filteredCarriers.includes(c.id)
    );

    // Limita los carriers seleccionados a los disponibles
    const selectedCarriers = this.formBulk.get('bulkCarriers')?.value || [];
    const filteredCarrierIds = this.carriersListFiltered.map((c: any) => c.id);
    const updatedCarriers = selectedCarriers.filter((id: any) => filteredCarrierIds.includes(id));
    this.formBulk.get('bulkCarriers')?.setValue(updatedCarriers);
  }
  
  ruSure() {
    if(this.formBulk.invalid) { return; }
    Swal.fire({
      title: '¿Estás seguro que deseas guardar el registro?',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {      
      if (result.isConfirmed) {
        //console.log(this.formCreate.value);
        this.save();
      }
    });
  }

  save() {
    Swal.fire({
      icon: 'info',
      title: 'Guardando...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        // Swal.showLoading(null);
      }
    });
    this.distService.setBulkConfig(this.formBulk.getRawValue(), this.campana.id).subscribe(
      (result:any) => {
        if(result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: '¡Configuración guardada de manera correcta!'          
          }).then(() => {            
            this.dialogRef.close({ reload: false });
          });
        }
      },
      (err:any) => {        
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
          });
      }
    );
  }
  
  resetForm() {
    this.selected = [];
    this.formBulk.reset();
  }

}
